import { createContext, useContext, useState } from "react";


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isApiLoading,setIsApiLoading] = useState(false)

  return (
    <AuthContext.Provider value={{ isApiLoading,setIsApiLoading}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
